import React from 'react';
import { SvgIcon } from '@material-ui/core';

const DocumentsIcon = (props) => {
  return(
    <SvgIcon viewBox="0 0 250 250" {...props}>
      <g id="documents" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-35.000000, -36.000000)" fillRule="nonzero">
          <circle id="Mask" fill="#2EBCAE" transform="translate(160.500000, 160.500000) rotate(-23.250000) translate(-160.500000, -160.500000) " cx="160.5" cy="160.5" r="122.035345"></circle>
          <path d="M218,115.5 L276.877878,197.223435 C266.554491,229.886655 242.613941,258.039414 208.670407,272.622707 C186.547893,282.127289 163.169185,284.582154 141.042199,280.987858 L103,242.5 L218,115.5 Z" id="Combined-Shape" fill="#199D8E"></path>
        </g>
        <path d="M141.085,39 L183,74.802 L183,202 C183,206.418278 179.418278,210 175,210 L76,210 C71.581722,210 68,206.418278 68,202 L68,47 C68,42.581722 71.581722,39 76,39 L141.085,39 Z" id="Combined-Shape" fill="#FFFFFF"></path>
        <rect id="Rectangle" fill="#2EBCAE" x="81" y="96" width="90" height="9" rx="4.5"></rect>
        <rect id="Rectangle" fill="#2EBCAE" x="81" y="116" width="90" height="9" rx="4.5"></rect>
        <rect id="Rectangle" fill="#2EBCAE" x="81" y="136" width="90" height="9" rx="4.5"></rect>
        <polyline id="Path-7" stroke="#2EBCAE" strokeWidth="4" strokeLinejoin="round" points="141 39 141 76 183 76"></polyline>
      </g>
    </SvgIcon>
  );
};

export default DocumentsIcon;
